import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IOverviewPagination } from '@shared/models';
import { BehaviorSubject, filter, map } from 'rxjs';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
})
export class PaginatorComponent {
  readonly pagination$ = new BehaviorSubject<IOverviewPagination>({} as IOverviewPagination);
  readonly data$ = new BehaviorSubject<unknown[]>([]);

  @Input() set pagination(value: IOverviewPagination) {
    this.pagination$.next(value);
  }

  @Input() set data(value: unknown[]) {
    this.data$.next(value);
  }

  @Output() onPaginate = new EventEmitter<any>();

  showPaginator$ = this.pagination$.pipe(
    filter((p) => !!p),
    map((p) => p.totalItems > p.pageSize),
  );
}
